(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("wanakana"));
	else if(typeof define === 'function' && define.amd)
		define(["wanakana"], factory);
	else if(typeof exports === 'object')
		exports["../wanakana"] = factory(require("wanakana"));
	else
		root["../wanakana"] = factory(root["wanakana"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_wanakana__) => {
return 